import { render, staticRenderFns } from "./investmentAimMange.vue?vue&type=template&id=7cdf730a&scoped=true&"
import script from "./investmentAimMange.vue?vue&type=script&lang=js&"
export * from "./investmentAimMange.vue?vue&type=script&lang=js&"
import style0 from "./investmentAimMange.vue?vue&type=style&index=0&id=7cdf730a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdf730a",
  null
  
)

export default component.exports